module.exports = __webpack_public_path__ + "static/media/12625817_1531927360435056_1403346285_n.28a39f63.jpg";